import React, { useMemo } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import { map } from "lodash";
import NotFound from "@/pages/NotFound/NotFound";
import Dashbord from "./dashbord";

const loadableProps = {
  timeout: 60 * 1000,
};
const Loading = () => null;

// 新加的
const FindDetail = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Supplier/FindDetail" /* webpackChunkName:'FindDetail' */),
  loading: Loading,
});

const SampleList = Loadable({
  ...loadableProps,
  loader: () =>
    import("../SampleList/index" /* webpackChunkName:'SampleList' */),
  loading: Loading,
});

const ExpertMessage = Loadable({
  ...loadableProps,
  loader: () =>
    import("../ExpertMessage/index" /* webpackChunkName:'ExpertMessage' */),
  loading: Loading,
});

const Envconfig = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Envconfig/Envconfig" /* webpackChunkName:'Envconfig' */),
  loading: Loading,
});

const HomePage = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Envconfig/HomePage" /* webpackChunkName:'HomePage' */),
  loading: Loading,
});

const Warning = Loadable({
  ...loadableProps,
  loader: () => import("../Sample/Warning" /* webpackChunkName:'Warning' */),
  loading: Loading,
});

const Home = Loadable({
  ...loadableProps,
  loader: () => import("../Envconfig/Home" /* webpackChunkName:'Home' */),
  loading: Loading,
});

const ScoreConfigAdd = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Score/ScoreConfigAdd" /* webpackChunkName:'ScoreConfigAdd' */),
  loading: Loading,
});

const ScoreDeployAdd = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Score/ScoreDeployAdd" /* webpackChunkName:'ScoreDeployAdd' */),
  loading: Loading,
});

const InvitationCreate = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      "../InvitationCreate/InvitationCreate" /* webpackChunkName:'InvitationCreate' */
    ),
  loading: Loading,
});

const ScoreConfigTamplate = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      "../Score/ScoreConfigTamplate" /* webpackChunkName:'ScoreConfigTamplate' */
    ),
  loading: Loading,
});

const PaySuccess = Loadable({
  ...loadableProps,
  loader: () => import("./PaySuccess" /* webpackChunkName:'PaySuccess' */),
  loading: Loading,
});

const Tkauth = Loadable({
  ...loadableProps,
  loader: () => import("./Tkauth" /* webpackChunkName:'Tkauth' */),
  loading: Loading,
});

const SearchDetail = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Search/SearchDetail" /* webpackChunkName:'SearchDetail' */),
  loading: Loading,
});

const GroupDetail = Loadable({
  ...loadableProps,
  loader: () =>
    import("../UserGroup/GroupDetail" /* webpackChunkName:'GroupDetail' */),
  loading: Loading,
});

const Mine = Loadable({
  ...loadableProps,
  loader: () => import("../Mine/Mine" /* webpackChunkName:'Mine' */),
  loading: Loading,
});

const MineList = Loadable({
  ...loadableProps,
  loader: () => import("../Mine/MineList" /* webpackChunkName:'Mine' */),
  loading: Loading,
});

const MineOrderList = Loadable({
  ...loadableProps,
  loader: () => import("../Mine/MineOrderList" /* webpackChunkName:'Mine' */),
  loading: Loading,
});

const CreatorDetail = Loadable({
  ...loadableProps,
  loader: () =>
    import("../Mine/CreatorDetail" /* webpackChunkName:'CreatorDetail' */),
  loading: Loading,
});

const RouterList = ($$) => {
  const renderRouterList = () => {
    const renderRouteList = (menuList) => {
      return map(menuList, (M) => {
        if (M.type === 1 && M.subMenu.length === 0 && M.path && M.component) {
          return (
            <Route exact path={M.path} key={M.id}>
              {M.component ? (
                <M.component
                  userId={$$.id}
                  userName={$$.userName}
                  globalHistory={$$.history}
                  authInfo={M.authInfo}
                  permissions={M.permissions}
                />
              ) : null}
            </Route>
          );
        }

        return renderRouteList(M.subMenu);
      });
    };

    return (
      <Switch>
        {/* <Redirect from="/" to="/envconfig" /> */}
        <Route exact path="/" render={() => <Home />} />
        {renderRouteList($$.menuList)}
        <Route
          exact
          path="/find/detail/:id/:tmpid?"
          render={() => <FindDetail />}
        />
        <Route exact path="/sample/sampleList" render={() => <SampleList />} />
        <Route
          exact
          path="/expert/expertmessage"
          render={() => <ExpertMessage />}
        />
        <Route exact path="/envconfigFooter" render={() => <Envconfig />} />
        <Route exact path="/envconfig" render={() => <HomePage />} />
        <Route exact path="/warning" render={() => <Warning />} />
        {/* <Route
          exact
          path="/scoreConfig/add/:id?"
          render={() => <ScoreConfigAdd />}
        /> */}
        <Route
          exact
          path="/scoreConfig/tamplate/:id"
          render={() => <ScoreConfigTamplate />}
        />
        <Route
          exact
          path="/ScoreDeploy/add/:id?/:tamplateId?"
          render={() => <ScoreDeployAdd />}
        />
        <Route
          exact
          path="/invitation/create"
          render={() => <InvitationCreate />}
        />
        <Route
          exact
          path="/search/detail/:id/:type/:source?"
          render={() => <SearchDetail />}
        />
        <Route exact path="/paySuccess" render={() => <PaySuccess />} />
        <Route exact path="/tkauth" render={() => <Tkauth />} />
        <Route exact path="/mine" render={() => <Mine />} />
        <Route exact path="/mine/list" render={() => <MineList />} />
        <Route exact path="/mine/orderlist" render={() => <MineOrderList />} />
        <Route
          exact
          path="/group/detail/:id/:name"
          render={() => <GroupDetail />}
        />
        <Route
          exact
          path="/group/detail/:id/:name"
          render={() => <GroupDetail />}
        />
        <Route
          exact
          path="/creator/detail/:id"
          render={() => <CreatorDetail />}
        />
        <Route component={NotFound} />
      </Switch>
    );
  };

  const routerItems = useMemo(renderRouterList, [$$.length]);

  return routerItems;
};

export default RouterList;
